export const demographics = [
  {
    patientId: "10",
    fullName: "Doroty K Johnson Jr.",
    dateOfBirth: "04/23/1952 (72y)",
    timeOfBirth: "—",
    sex: "Female",
    race: "White",
    ethnicityCode: "Not Hispanic or Latino",
    language: "English",
    maritalStatus: "Married",
    patientNumber: "123456789",
    socialSecurityNumber: "123-45-6789",
    preferredName: "—",
    formerName: "—",
    nickname: "—",
    birthStateCode: "—",
    birthCountryCode: "—",
    bloodType: "—",

    referringProvider: "—",
    referringProviderPhone: "—",
    pcpProvider: "—",
    pcpProviderPhone: "—",
    usualCaregiver: "Urgent Care, BCHC",
    usualCaregiverPhone: "240-349-7750",
    privacyStatus: "Any Caregiver",

    homeAddress: "3098 Wilkinson Blvd",
    homeCityStateZip: "Charlotte, NC, 28217",
    homeCounty: "Lee",
    homeCrossStreet: "—",
    homePhone: "560-378-0264",
    homeCarPhone: "560-249-7712",
    homeFax: "—",
    homePager: "—",
    homeEmail: "cadence.anna@yopmail.com",
    homeStartDate: "—",
    homeEndDate: "—",

    officeAddress: "3098 Wilkinson Blvd",
    officeCityStateZip: "Charlotte, NC, 28217",
    officeCounty: "Lee",
    officeCrossStreet: "—",
    officePhone: "560-378-0264",
    officeCarPhone: "560-249-7712",
    officeFax: "—",
    officePager: "—",
    officeEmail: "—",
    officeStartDate: "—",
    officeEndDate: "—",

    employer: "—",
    employerStatus: "Undefined",
    occupation: "—",
    industry: "—",

    guarantorFullName: "Alice Johnson",
    guarantorRelationship: "Daughter",
    guarantorSex: "Female",
    guarantorDateOfBirth: "—",
    guarantorSSN: "XXX-XX-4585",

    guarantorHomeAddress: "7421 Cedar Glen Dr",
    guarantorHomeCityStateZip: "Charlotte, NC, 28215",
    guarantorHomeCounty: "Mecklenburg",
    guarantorHomeCrossStreet: "—",
    guarantorHomePhone: "584-400-0669",
    guarantorHomeCarPhone: "584-408-0102",
    guarantorHomeFax: "—",
    guarantorHomePager: "—",
    guarantorHomeEmail: "alice.johnson@yopmail.com",
    guarantorHomeStartDate: "—",
    guarantorHomeEndDate: "—",

    guarantorOfficeAddress: "1834 Willow Creek Ln",
    guarantorOfficeCityStateZip: "Charlotte, NC, 28262",
    guarantorOfficeCounty: "Mecklenburg",
    guarantorOfficeCrossStreet: "—",
    guarantorOfficePhone: "604-288-0671",
    guarantorOfficeCarPhone: "604-230-8596",
    guarantorOfficeFax: "—",
    guarantorOfficePager: "—",
    guarantorOfficeEmail: "—",
    guarantorOfficeStartDate: "—",
    guarantorOfficeEndDate: "—",

    pharmacyName: "EZRX Bonita Springs",
    pharmacyAddress: "3501 Health Center Blvd Ste 1200",
    pharmacyCityStateZip: "Estero, FL, 34135",
    pharmacyCounty: "—",
    pharmacyCrossStreet: "—",
    pharmacyPhone: "239-301-5058",
    pharmacyCarPhone: "—",
    pharmacyFax: "239-790-5182",
    pharmacyPager: "—",
    pharmacyEmail: "rx20@mychoicerx.net",

    status: "Active",
    patientType: "1",
    medicAlert: "—",
    organDonor: "—",
    vipIndicator: "—",

    chartId: "—",
    accountId: "—",
    releaseOfInfo: "0",
    hcfaSignature: "0",
    notifyMethod: "0",

    contacts: [
      {
        lastName: "Johnson",
        firstName: "Michael",
        middleName: "—",
        relationship: "Spouse",
        emergency: "YES",
        phone: "708-859-5614",
      },
      {
        lastName: "Johnson",
        firstName: "Alice",
        middleName: "—",
        relationship: "Daughter",
        emergency: "YES",
        phone: "708-899-0102",
      },
      {
        lastName: "Smith",
        firstName: "Naomi",
        middleName: "—",
        relationship: "Sister",
        emergency: "YES",
        phone: "944-963-1124",
      },
    ],
    ui: {
      downloadLinks: {
        csv: "https://drive.google.com/uc?export=download&id=17kFlz2x2Jea0aQNEsU9Dw7C6XZhPFwdi",
        pdf: "https://drive.google.com/uc?export=download&id=1LQFjjZ7Ux01PUkMOMruIs5YF-g81AXHN",
        xls: "https://docs.google.com/spreadsheets/d/1Xlil-GYmyZNbOSsxgebe9mDcikpsMqnc/export?format=xlsx",
      },
    },
  },
  {
    patientId: "11",
    fullName: "Cadence Anna",
    dateOfBirth: "04/23/1952 (72y)",
    timeOfBirth: "—",
    sex: "Female",
    race: "White",
    ethnicityCode: "Not Hispanic or Latino",
    language: "English",
    maritalStatus: "Married",
    patientNumber: "123456789",
    socialSecurityNumber: "123-45-6789",
    preferredName: "—",
    formerName: "—",
    nickname: "—",
    birthStateCode: "—",
    birthCountryCode: "—",
    bloodType: "—",

    referringProvider: "—",
    referringProviderPhone: "—",
    pcpProvider: "—",
    pcpProviderPhone: "—",
    usualCaregiver: "Urgent Care, BCHC",
    usualCaregiverPhone: "240-349-7750",
    privacyStatus: "Any Caregiver",

    homeAddress: "3098 Wilkinson Blvd",
    homeCityStateZip: "Charlotte, NC, 28217",
    homeCounty: "Lee",
    homeCrossStreet: "—",
    homePhone: "560-378-0264",
    homeCarPhone: "560-249-7712",
    homeFax: "—",
    homePager: "—",
    homeEmail: "cadence.anna@yopmail.com",
    homeStartDate: "—",
    homeEndDate: "—",

    officeAddress: "3098 Wilkinson Blvd",
    officeCityStateZip: "Charlotte, NC, 28217",
    officeCounty: "Lee",
    officeCrossStreet: "—",
    officePhone: "560-378-0264",
    officeCarPhone: "560-249-7712",
    officeFax: "—",
    officePager: "—",
    officeEmail: "—",
    officeStartDate: "—",
    officeEndDate: "—",

    employer: "—",
    employerStatus: "Undefined",
    occupation: "—",
    industry: "—",

    guarantorFullName: "Alice Johnson",
    guarantorRelationship: "Daughter",
    guarantorSex: "Female",
    guarantorDateOfBirth: "—",
    guarantorSSN: "XXX-XX-4585",

    guarantorHomeAddress: "7421 Cedar Glen Dr",
    guarantorHomeCityStateZip: "Charlotte, NC, 28215",
    guarantorHomeCounty: "Mecklenburg",
    guarantorHomeCrossStreet: "—",
    guarantorHomePhone: "584-400-0669",
    guarantorHomeCarPhone: "584-408-0102",
    guarantorHomeFax: "—",
    guarantorHomePager: "—",
    guarantorHomeEmail: "alice.johnson@yopmail.com",
    guarantorHomeStartDate: "—",
    guarantorHomeEndDate: "—",

    guarantorOfficeAddress: "1834 Willow Creek Ln",
    guarantorOfficeCityStateZip: "Charlotte, NC, 28262",
    guarantorOfficeCounty: "Mecklenburg",
    guarantorOfficeCrossStreet: "—",
    guarantorOfficePhone: "604-288-0671",
    guarantorOfficeCarPhone: "604-230-8596",
    guarantorOfficeFax: "—",
    guarantorOfficePager: "—",
    guarantorOfficeEmail: "—",
    guarantorOfficeStartDate: "—",
    guarantorOfficeEndDate: "—",

    pharmacyName: "EZRX Bonita Springs",
    pharmacyAddress: "3501 Health Center Blvd Ste 1200",
    pharmacyCityStateZip: "Estero, FL, 34135",
    pharmacyCounty: "—",
    pharmacyCrossStreet: "—",
    pharmacyPhone: "239-301-5058",
    pharmacyCarPhone: "—",
    pharmacyFax: "239-790-5182",
    pharmacyPager: "—",
    pharmacyEmail: "rx20@mychoicerx.net",

    status: "Active",
    patientType: "1",
    medicAlert: "—",
    organDonor: "—",
    vipIndicator: "—",

    chartId: "—",
    accountId: "—",
    releaseOfInfo: "0",
    hcfaSignature: "0",
    notifyMethod: "0",

    contacts: [
      {
        lastName: "Johnson",
        firstName: "Michael",
        middleName: "—",
        relationship: "Spouse",
        emergency: "YES",
        phone: "708-859-5614",
      },
      {
        lastName: "Johnson",
        firstName: "Alice",
        middleName: "—",
        relationship: "Daughter",
        emergency: "YES",
        phone: "708-899-0102",
      },
      {
        lastName: "Smith",
        firstName: "Naomi",
        middleName: "—",
        relationship: "Sister",
        emergency: "YES",
        phone: "944-963-1124",
      },
    ],
    ui: {
      downloadLinks: {
        csv: "https://drive.google.com/uc?export=download&id=17kFlz2x2Jea0aQNEsU9Dw7C6XZhPFwdi",
        pdf: "https://drive.google.com/uc?export=download&id=1LQFjjZ7Ux01PUkMOMruIs5YF-g81AXHN",
        xls: "https://docs.google.com/spreadsheets/d/1Xlil-GYmyZNbOSsxgebe9mDcikpsMqnc/export?format=xlsx",
      },
    },
  },
];
